import { MultiItems } from 'src/components/multi-items';

export default MultiItems;
